<template>
    <Modal :title="$t('customRating.editModal.title')"
           :close-on-click-outside="false"
           @close="closeModal()"
    >
        <template v-slot:body>
            <form class="base_margin modal-content" style="margin-top: 0">
				<CompanySearchSelect
					v-if="!isEditMode"
					@input="selectCompany"
					:search-function="searchCompany"
				></CompanySearchSelect>
				<template v-if="selectedCompany.name">
					<md-field displayOnly>
						<label>{{$t("common.company")}}</label>
						<md-input :value="selectedCompany.name" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{$t("common.vatId")}}</label>
						<md-input :value="selectedCompany.taxNum" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{$t("common.address")}}</label>
						<md-input :value="buildDisplayAddress(selectedCompany)" disabled></md-input>
					</md-field>
					<md-field>
						<label>{{ config.nameRating1OrDefault }}</label>
						<MoneyAmountInput v-model="form.rating1" :decimals="0"></MoneyAmountInput>
					</md-field>
					<md-field>
						<label>{{ config.nameRating2OrDefault }}</label>
						<MoneyAmountInput v-model="form.rating2" :decimals="0"></MoneyAmountInput>
					</md-field>
					<md-field>
						<label>{{ config.nameRating3OrDefault }}</label>
						<MoneyAmountInput v-model="form.rating3" :decimals="0"></MoneyAmountInput>
					</md-field>
				</template>
            </form>
            <div class="flex flex_between">
                <md-button class="md-blank" @click="closeModal()">{{ $t("common.button.cancel") }}</md-button>
                <md-button
                    class="md-primary"
                    @click="submit"
                >{{ $t("common.button.submit") }}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal.vue";
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput.vue";
import {customRatingsApi} from "@/common/api/customRatingsApi";
import CompanySearchSelect from "@/components/templates/common/CompanySearchSelect.vue";

export default {
    components: {
	    CompanySearchSelect,
        Modal,
        MoneyAmountInput,
    },
    props: {
        companyId: { type: Object, default: null },
	    config: { type: Object, default: null },
    },
    data() {
        return {
            form: {
                id: null,
				companyId: null,
                rating1: null,
				rating2: null,
				rating3: null,
            },
			isEditMode: false,
	        selectedCompany: {
		        name: null,
		        vat: null,
		        address: {
					street: null,
					postcode: null,
					city: null
				}
	        },
			searchResults: null
        };
    },
	created() {
		if (this.companyId != null) {
			this.isEditMode = true;
			this.loadData();
		} else {
			this.isEditMode = false;
		}
	},
    methods: {
	    loadData() {
            customRatingsApi.inspection.getCustomRating(this.companyId)
                .then(this.updateForm)
                .catch(this.toast);
	    },
		buildDisplayAddress(data) {
			// No name equals incomplete company data
			if (!data.name) {
				return "";
			}

			return data.street + ", " + data.postcode + ", " + data.city;
		},
		searchCompany(searchValue) {
			return customRatingsApi.inspection.searchCompany({ identifier: searchValue })
				.then(res => {
					this.searchResults = res;

					return res;
				});
		},
		selectCompany(data) {
			this.updateForm(this.searchResults.find(company => company.id === data.id));
		},
		updateForm(companyWithRatings) {
			this.form = {
				id: companyWithRatings.ratingId,
				companyId: companyWithRatings.id,
				rating1: companyWithRatings.rating1,
				rating2: companyWithRatings.rating2,
				rating3: companyWithRatings.rating3
			};

			this.selectedCompany = companyWithRatings;
		},
        closeModal() {
            this.$emit("close");
        },
        submit() {
            this.$emit("submit", this.form)
        },
    },
};
</script>